<div class="banner d-lg-flex d-none">
  <div class="container d-flex justify-content-between align-items-center h-100">
    <h1>{{ 'bulls.pay.page.title' | translate }}</h1>
    <div class="d-flex align-items-center">
      <img class="banner-logo" src="assets/images/Logos/RedbullsMemberPlusWhite.svg" />
    </div>
  </div>
</div>

<fgb-page-header [pageTitle]="'bulls.pay.page.title'" [backButtonLink]="'/'"></fgb-page-header>

<div class="d-block d-lg-none">
  <div class="container">
    <ul class="payment-nav ps-0">
      <a class="nav-item" [routerLink]="['/ecash']" [routerLinkActive]="'active'" [routerLinkActiveOptions]="{ exact: true }">
        <label>{{ 'nav.card' | translate }}</label>
      </a>
      <a
        class="nav-item"
        [routerLink]="['/ecashhistory']"
        [routerLinkActive]="'active'"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        <label>{{ 'nav.ecash.history' | translate }}</label>
      </a>
    </ul>
  </div>

  <div class="container mt-4">
    <div class="ecash-history">
      <h2 class="font-size-14 my-0">{{ 'transaction.history.title' | translate }}</h2>
      <fgb-transaction-history [transactionTypes]="[transactionTypes.payment]" [ecashView]="true"></fgb-transaction-history>
    </div>
  </div>
</div>
